
export const materialTheame = {
  backgroundColor: "#6a1b9a",
  textColor: "#ebdbf5",
  button: {
    textColor: "#6a1b9a",
    backgroundColor: "#ebdbf5",
    disabledBackground: '#333'
  },
};
export const sharpTheame = {
  backgroundColor: "#ffeb3b",
  textColor: "#292500",
  button: {
    textColor: "#FFFFFF",
    backgroundColor: "#292500",
    disabledBackground: '#333'
  },
};
export const cherryBonBonTheame = {
  backgroundColor: "#c62828",
  textColor: "#ffeeed",
  button: {
    textColor: "#c62828",
    backgroundColor: "#ffeeed",
    disabledBackground: '#333'
  },
};
export const seaWaveTheame = {
  backgroundColor: "#9be7ff",
  textColor: "#0d47a1",
  button: {
    textColor: "#ffffff",
    backgroundColor: "#0d47a1",
    disabledBackground: '#333'
  },
};

